import {io} from 'socket.io-client';
import { usePcsAuthRep } from 'src/context/pcs-auth-context';
import { useQueryClient } from 'react-query';
import { useEffect, useState, useContext } from 'react';
import { SocketContext } from 'src/context/socket-context';
import { updateEventDataAC } from 'src/context/socket-context';

let holodeckHubUserEventSocketInitialized = false;
export const usePcsUserEventSocketHolodeckHub = ({eventId, enabled}: {eventId: number, enabled: boolean }) => {

    const { token } = usePcsAuthRep();
    const queryClient = useQueryClient();
      const [_, socketDispatch] = useContext(SocketContext);

    const [holodeckHubSocketState, setHolodeckHubSocketState] = useState(null);

    // In order to allow for failover to socket-router if HH fails to connect, track the state of "currently attempting to connect"
    const [attemptingToConnect, setAttemptingToConnect] = useState(true);

    if(enabled) {

        if (!holodeckHubUserEventSocketInitialized) {

            const socketUrl = `${process.env.REACT_APP_HOLODECK_HUB_SOCKETIO_URL}`;

            const holodeckHubSocket = io(socketUrl, {
                path: '/event-ws',
                auth: {
                    token: `Bearer ${token}`
                },
                transports: ["websocket"],
                autoConnect: true,
                query: {
                    event_id: eventId
                }
            });

            // Listen for standard socket.io connection lifecycle events
            holodeckHubSocket.on("connect", (...args) => {
                console.log(`Holodeck Hub Socket /event-ws - Connected! ${holodeckHubSocket?.id}`, args);
                setAttemptingToConnect(false); // Once connected, we no longer need this flag
            });

            holodeckHubSocket.on("connect_error", (error: Error) => {
                if (holodeckHubSocket?.active) {
                // temporary failure, the socket will automatically try to reconnect
                console.log("Holodeck Hub Socket /event-ws - Temporary Failure, automatically reconnecting...");
                } else {
                // the connection was denied by the server
                // in that case, `socket.connect()` must be manually called in order to reconnect
                console.log("Holodeck Hub Socket /event-ws - Fatal Error.");
                }
                console.log(`${holodeckHubSocket?.id} - ${error.name} - ${error.message}`);
                setAttemptingToConnect(false); // Once we get a connection error, tell AP to try connecting to socket-router instead
            });

            holodeckHubSocket.on("disconnect", (reason: string, details: any) => {
                if (holodeckHubSocket?.active) {
                // temporary disconnection, the socket will automatically try to reconnect
                console.log("Holodeck Hub Socket /event-ws - Temporary Disconnect, automatically reconnecting...");
                } else {
                // the connection was forcefully closed by the server or the client itself
                // in that case, `socket.connect()` must be manually called in order to reconnect
                console.log("Holodeck Hub Socket /event-ws - Disconnected");
                }
                console.log(`${holodeckHubSocket?.id} - ${reason} - ${details?.toString()}`);
            });


            holodeckHubSocket.on('update-event', (data) => {

                // TODO: test that we're reading data correctly everywhere in here

                // If the backend tells us there is new data for an event
                // we invalidate the query so that react-query refetches new events
                if (data?.entity?.[0] === "update-event") {
                    const id = data.id ?? data.eventId;
                    const queryKey = [...data.entity, id].filter(Boolean);
                    queryClient.invalidateQueries(queryKey);

                    // If the backend tells us there are updates to an event, apply them
                    socketDispatch(updateEventDataAC(data));
                }
            });

            setHolodeckHubSocketState(holodeckHubSocket);
            holodeckHubUserEventSocketInitialized = true;
        }
    }

  useEffect(() => {
    return () => {
      holodeckHubSocketState?.disconnect();
      holodeckHubUserEventSocketInitialized = false;
    }
  }, []);

    return {holodeckHubSocket: holodeckHubSocketState, attemptingToConnect: attemptingToConnect && !holodeckHubUserEventSocketInitialized};

}

